/**
 * Constantes de localización en español para componentes de fecha
 */
export const ES_DATE_LOCALE = {
  firstDayOfWeek: 1,
  dayNames: [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],
  today: 'Hoy',
  clear: 'Limpiar',
  dateFormat: 'dd/mm/yy',
};

/**
 * Nombres de meses en español con primera letra mayúscula
 * Usado para formateo de fechas y períodos
 */
export const MONTH_NAMES_CAPITALIZED = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export function getChileTimeZone() {
  const formatter = Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Santiago',
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(new Date());

  // Revisando si es "GMT-3" o "GMT-4"
  const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value;

  if (tzPart == 'GMT-3') return '-03:00';
  return '-04:00';
}

export function getPeriodosDesde(
  fechaDesde: Date,
): Array<{ name: string; id: string }> {
  const periodos: Array<{ name: string; id: string }> = [];
  const meses = MONTH_NAMES_CAPITALIZED;

  const fechaActual = new Date();
  const fechaInicio = new Date(
    fechaDesde.getFullYear(),
    fechaDesde.getMonth(),
    1,
  );
  const fechaFin = new Date(
    fechaActual.getFullYear(),
    fechaActual.getMonth(),
    1,
  );

  let fechaActualPeriodo = new Date(fechaInicio);

  while (fechaActualPeriodo <= fechaFin) {
    const año = fechaActualPeriodo.getFullYear();
    const mes = fechaActualPeriodo.getMonth();
    const mesStr = String(mes + 1).padStart(2, '0');
    const id = `${año}${mesStr}`;
    const name = `${meses[mes]} ${año}`;

    periodos.push({ name, id });

    // Avanzar al siguiente mes
    fechaActualPeriodo = new Date(año, mes + 1, 1);
  }

  periodos.reverse();
  return periodos;
}

const FERIADOS: Record<number, string[]> = {
  2026: [
    '0101',
    '0304',
    '0404',
    '0105',
    '2105',
    '2106',
    '2906',
    '1607',
    '1508',
    '1809',
    '1909',
    '1210',
    '3110',
    '0111',
    '0812',
    '2512',
  ],
  2027: [
    '0101',
    '2603',
    '2703',
    '0105',
    '2105',
    '2106',
    '2806',
    '1607',
    '1508',
    '1709',
    '1809',
    '1909',
    '1110',
    '3110',
    '0111',
    '0812',
    '2512',
  ],
  2028: [
    '0101',
    '1404',
    '1504',
    '0105',
    '2105',
    '2006',
    '2606',
    '1508',
    '1809',
    '1909',
    '0910',
    '0111',
    '0812',
    '2512',
  ],
};

function formatearFeriado(year: number, ddmm: string): string {
  const day = ddmm.slice(0, 2);
  const month = ddmm.slice(2, 4);
  return `${year}-${month}-${day}`;
}

export function diasHabilesDesde(
  fechaInicio: Date,
  fechaFin: Date = new Date(),
): number {
  let count = 0;
  const current = new Date(fechaInicio);

  while (current <= fechaFin) {
    const day = current.getDay(); // 0 domingo, 6 sábado
    const year = current.getFullYear();

    const esFinDeSemana = day === 0 || day === 6;

    const feriadosDelAno = FERIADOS[year] || [];
    const fechaStr = current.toISOString().split('T')[0];

    const esFeriado = feriadosDelAno
      .map((f) => formatearFeriado(year, f))
      .includes(fechaStr);

    if (!esFinDeSemana && !esFeriado) {
      count++;
    }

    current.setDate(current.getDate() + 1);
  }

  return count;
}
